module.exports = __webpack_public_path__ + "static/img/content-2.d42ed12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/content-2.png
// module id = unQT
// module chunks = 1